import React, { ForwardRefRenderFunction } from "react";
import { twMerge } from "tailwind-merge";

type TextAreaProps = {
  label?: string;
  error?: string;
  className?: string;
  InputProps?: {
    className?: string;
  };
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const PlainTextArea: ForwardRefRenderFunction<
  HTMLTextAreaElement,
  TextAreaProps
> = ({ rows = 4, label, error, className, InputProps, ...props }, ref) => {
  return (
    <div className={twMerge(label && "flex flex-col gap-1", className)}>
      {label && (
        <label htmlFor={props.id} className="ml-1 text-base font-semibold">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        rows={rows}
        className={twMerge(
          "block",
          "w-full",
          "rounded-lg",
          "border-0",
          "p-1.5",
          "text-gray-900",
          "shadow-sm",
          "ring-inset",
          "placeholder:text-gray-500",
          "focus:outline-none",
          "focus:ring-2",
          "border-gray-500",
          "border",
          "sm:leading-6",
          props.disabled && "bg-gray-100 placeholder:text-gray-600",
          InputProps?.className,
          error && "ring-1 ring-error border-error",
        )}
        {...props}
      />
      {error && <p className="ml-1 mt-1 text-base text-red-500">{error}</p>}
    </div>
  );
};

export const TextArea = React.forwardRef(PlainTextArea);
